import React from 'react'
import cx from 'classnames'
import _ from 'lodash'

import { DropDownIcon } from '../icons'

import S from './styled'

const Select = ({
  name, title, label, select,
  onAdd,
  error,
  validateOnBlur = true, validate,
  values,
  inverted,
  defaultValue,
  disabled,
  style,
  noEmpty,
  integerValue = true,
  ...props
}) => {

  const selectProps = select({
    name,
    validateOnBlur,
    validate,
    defaultValue,
    disabled,
    integerValue,
  })

  return (
    <S.Input style={style}>
      {title && <label {...(typeof label === 'function' ? label(name) : {})}>{title}</label>}
      <S.InputContainer error={!!(error || selectProps.error)} inverted={inverted}>
        <select {...selectProps} {...props} disabled={disabled}>
          {!noEmpty && (<option value=""></option>)}
          {
            _.uniqBy(values, value => value.id )
              .map(option => <option value={option.id} key={option.id}>{option.name}</option>)
          }
        </select>
        <S.Icon className={cx('onHover', {
          disabled,
        })}><DropDownIcon/></S.Icon>
      </S.InputContainer>
      {
        (error || selectProps.error) && <S.ErrorLabel>{(error || selectProps.error)}</S.ErrorLabel>
      }
    </S.Input>
  )
}

export default Select
